export default "__VITE_ASSET__11ba07f7__"